<template>
  <div class="querty_content queryCourse coursewareModle">
    <!--面包屑-->
    <div class="crumbs">
      <!-- <span><router-link :to="{name:'Transition'}">首页</router-link></span> > -->
       <span>首页</span>>
      <span><router-link :to="{name:'CourseWare'}">教学课件</router-link></span> >
      <span>查看课件</span>
    </div>
    <div class="w98 course_query">
      <div class="course_top">
        <el-row style="padding-top: 15px;">
          <el-col :span="10">
            <span class="label_title">课件名称：</span>
            <span class="info_content">{{this.detailList.subject}}</span>
          </el-col>
          <el-col :span="6">
            <span class="label_title">课件分类：</span>
            <span class="info_content">{{this.detailList.courseType}}</span>
          </el-col>
          <el-col :span="6">
            <span class="label_title">学科分类：</span>
            <span class="info_content">{{scienceTypeData}}</span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <span class="label_title">创建人：</span>
            <span class="info_content">{{this.detailList.creatorName}}</span>
          </el-col>
          <el-col :span="10">
            <span class="label_title">关键词：</span>
            <span class="info_content">{{this.detailList.keywords}}</span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <span class="label_title">是否公开：</span>
            <span class="info_content">{{this.detailList.openFlag}}</span>
          </el-col>
          <el-col :span="11" class="range" v-show="rangeShow">
            <span class="label_title">开放范围：</span>
            <div class="info_content dif_cont" :title="attend">
             <span v-for="item of attendL" >
                <b>{{item.name}}</b>
                <em v-show="item.attendEm">（{{item.job}}）</em> ，
            </span></div>

          </el-col>
        </el-row>
        <el-row class="remarkTxt">
          <el-col :span="24">
            <span class="label_title">课件简介：</span>
            <span class="info_content dif_info">{{this.detailList.remark}}</span>
          </el-col>
        </el-row>
      </div>

      <div style="margin-top: 20px; width:100%" class="clearfix">
        <div class="query_medicalRecord_left">
          <tabs @tabChange="tabChange"  :activeName="activeName">
               <!--附件-->
          <el-tab-pane name="0" class="p-table-text fj_contents">
                <span slot="label">附件({{detailList.attachList.length}})</span>
                <div class="list_title list_file_title">
                  文件类型
                </div>
                <div class="query_medicalRecord_left_file_content">
                  <div v-if="fileList.length === 0" class="nofile" >暂无上传文件</div>
                  <div v-else>
                    <p class="file_row" v-for="(item, index) in fileList" :key="index" :class="{check: index == fileI}" @click="fileCLick('file', item, index)">{{item.attach_name}}</p>
                  </div>
                </div>
                <div class="list_title list_file_title">
                  其他图片
                </div>
                <div class="query_medicalRecord_left_file_content">
                  <div v-if="picList.length === 0"  class="nofile">暂无上传图片</div>
                  <div v-else>
                    <p class="file_row2" v-for="(item, index) in picList" :key="index" :class="{check: index == picI}" @click="fileCLick('img', item, index)">{{item.attach_name}}</p>
                  </div>
                </div>
            </el-tab-pane>
            <el-tab-pane name="1" class="p-table-text">
                <span slot="label">影像({{detailList.studyList.length}})</span>
              <!--影像-->
              <div v-if="isImage === '1'">
                <div class="list_title">
                  <span style="width:26%;">检查编号</span>
                  <span style="width:10%;">性别</span>
                  <span style="width:10%;">年龄</span>
                  <span style="width:18%;">类型</span>
                  <span style="width:28%;">检查项目</span>
                </div>
                <div class="query_medicalRecord_left_image_content">
                  <div v-show="dataShow" v-for="(item, index) in detailList.studyList" :key="index" class="list_cell" :class="{check: index == this.i}" @click="_getReportInfo(item, index)">
                    <span style="width:26%;">{{item.accessionNumber}}</span>
                    <span style="width:10%;">{{item.patientSex}}</span>
                    <span style="width:10%;">{{item.patientAge}}</span>
                    <span style="width:18%;">{{item.examTypeName}}</span>
                    <span style="width:28%;" :title="item.examBodyName"><div class="litBit" v-if="item.examBodyName.length>'12'" :title="item.examBodyName">{{item.examBodyName}}</div><div v-else>{{item.examBodyName}}</div></span>
                  </div>
                  <div class="dataHide" v-show="dataHide">暂无数据</div>
                </div>
              </div>
             </el-tab-pane>
              <!--病例-->
              <el-tab-pane name="2" class="p-table-text selectClick dif_select">
                <span slot="label">病例({{detailList.caseList.length}})</span>
                <reportTable :head="head" :data="data"  @showDetial="showDetial"></reportTable>
               </el-tab-pane>
          </tabs>
        </div>
        <div class="query_medicalRecord_right query_course">
          <div v-if="isImage === '1'" class="reportContent">
            <h2><b>{{reportInfo.examTypeName}}</b>报告单
              <i class="btn btn2">电子病历</i>
              <i class="btn" @click="readFilm"  v-show="readFilmY">阅片</i>
              <i class="btn1"  v-show="readFilmN">阅片</i>
              <i class="btn btn3" @click="getReport">查看申请单</i>
            </h2>
            <report :info="reportInfo"></report>
          </div>
          <div class="file_area" v-if="isImage === '0'">
                    <div class="proTxt" v-show="defaultShow">
                            <div>
                              <img src="../../../../static/image/defaultpic.png" alt=""  height="140" />
                            </div>
                            <p :style="{'marginTop': '23px'}">暂无内容</p>
                    </div>

            <div v-if="imgShow=='1'" class="img_area">
              <img class="readImg" :src="url" @click="showBigImg()" alt="" width="80%">
            </div>
            <div v-if="imgShow=='0'" class="file_show">
              <p class="tip">暂不支持预览，请点击下载</p>
              <a :href="url">下载</a>
              <!--<iframe width="100%" height="100%" :src="url" frameborder="0"></iframe>-->
            </div>
          </div>
          <div v-if="isImage === '2'">
            <div class="tabTwo ">
              <tabs @tabChange="tabChangeRight" :activeName="'0'">
                <el-tab-pane v-for="tab in tabsRight" :label="tab.label" :name="tab.name" :key="tab.name" >
                  <!--病例信息-->
                  <div v-show="isImageTwo === '0'">
                    <medicalNewsDetail ref="child" :detailList="medicalDetail"></medicalNewsDetail>
                  </div>
                  <!--关联影像-->
                  <div v-show="isImageTwo === '1'" style="clearfix">
                    <pTable :head="head2" :data="data2" :operation="operation" @_operation="_operation_" :operationWidth="operationWidth" :autoheight="autoH"></pTable>
                  </div>
                  <!--病例附件-->
                  <div v-show="isImageTwo === '2'">
                    <uploadDetail :updateFileList="updateFileList" :updatePicList="updatePicList"></uploadDetail>
                  </div>
                </el-tab-pane>
              </tabs>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 弹出申请单 -->
    <pops v-if="repShow" :show="repShow" @closePop="closePop" :width="popwidth"  :classes="'Collections'" class="collect">
      <elcRep :elcRep="elcRep" :emergent="emergent"></elcRep>
    </pops>
    <!-- 弹出图片 -->
    <pops v-if="filePop" :show="filePop" :title="''" @closePop="closeFile" :class="'mrDialog'" :width="'980px'">
      <img :src="url" width="100%" alt="">
    </pops>
    <aycanImages ref="aycanImages" :hospitalId='params_image.hospitalId' :studyPk='params_image.studyPk' :studyUid='params_image.studyUid' ></aycanImages>
  </div>
</template>

<script>
  import tabs from '@/components/common/tabs/tabs'
  import report from '@/components/common/report/publicReport'
  import pTable from '@/components/common/tables/publicTable'
  import reportTable from '@/components/common/tables/reportTable'
  import medicalNewsDetail from '@/components/common/medicalNews/medicalNewsDetail'
  import uploadDetail from '@/components/common/upload/uploadDetail'
  import elcRep from '@/components/common/report/electronicReport'
  import {getLocalStorage, saveLocalStorage} from '@/common/js/localStorage'
  import http from '@/api/http'
  import * as _ from "@/common/js/config"
  import {changehosArea,changeAge,changeGender,changeSex,yinyang,changeclinicType} from '@/common/js/change'
  import {nomalTime} from '@/common/js/time'
  import {message} from '@/common/js/messages'
  import pops from '@/components/common/pops/pop'
  import aycanImages from '@/components/common/base/aycanImages'
  export default {
    components: {
      tabs,
      report,
      reportTable,
      medicalNewsDetail,
      pTable,
      uploadDetail,
      elcRep,
      pops,
      aycanImages
    },
    data() {
      return {
        popwidth: '80%',
        isImage: '0',
        url: '',
        scienceTypeData: '',
        imgShow: '',
        autoH:window.document.body.offsetHeight - 332,
        rangeShow: false,
        emergent:false,
        repShow: false,
        readFilmY:false,
        readFilmN:true,
        dataShow: false,
        defaultShow:true,
        dataHide: true,
        filePop: false,
        activeName:"0",
        name:'1',
        isImageTwo: '0',
        detail: {
        caseName:"",
        studyList:[]
        },
        reportShow:　true,
        elcRep:{},
        operationWidth: '80',
        detailList:[],
        fileList: [],
        readFirm: [],
        picList: [],
        casedetailList1:[],
        medicalDetail: {},
        tabsRight: [
          {
            label: '病例信息',
            name: '0'
          }, {
            label: '关联影像',
            name: '1'
          },
          {
            label: '病例附件',
            name: '2'
          }
        ],
        tabs: [
            {
            label: '附件',
            name: '0'
          },
          {
            label: '影像',
            name: '1'
          }, {
            label: '病例',
            name: '2'
          },

        ],
        head: [
          {
            props: 'caseName',
            label: '病例名称',
            width: '20%'
          },
          {
            props: 'caseSex',
            label: '性别',
            width: '10%'
          },
          {
            props: 'caseAge',
            label: '年龄',
            width: '10%'
          }
        ],
        data: [],
        attend:'',
        attendL:[],
        updateFileList:[],
        head2: [
          {
            props: "hospitalName",
            label: "来源"
          },
          {
            props: "examTypeName",
            label: "类型"
          },
          {
            props: "patientName",
            label: "姓名"
          },
          {
            props: "patientSex",
            label: "性别"
          },
          {
            props: "patientAge",
            label: "年龄"
          },
          {
            props: "examBodyName",
            label: "检查项目"
          }
        ],
        data2: [],
        updatePicList:[],
        reportInfo:{},
        operation: [
          {
            name: '阅片',
            operation: '',
            class: 'icon-yuepian'
          }
        ],
        params_image:{//阅片数据
          hospitalId:'',
          studyPk:'',
          studyUid:'',
        },
         check_applicat:{//查看申请单
          hospitalId:'',
          studyPk:0,
          studyUid:'',
        },
        picI:0,
        fileI:"",
      }
    },
    methods: {
      _operation_(payload) {
        if (payload.operation === 'icon-yuepian'){
          this.params_image.hospitalId = this.data2[payload.index].hospitalId;
          this.params_image.studyPk = this.data2[payload.index].studyPk+"";
          this.params_image.studyUid = this.data2[payload.index].studyUid;
          this.$nextTick(() => {
            this.$refs.aycanImages.getConsultImages();
          })
          // let Aycan = {
          //   hospitalId:this.data2[payload.index].hospitalId,
          //   studyPk:this.data2[payload.index].studyPk,
          //   studyUid:this.data2[payload.index].studyUid,
          // }
          // http.post('/edu/prepareAycan.json', Aycan).then(res => {
          //   if (res.data.code == "0000") {
          //     window.open(res.data.model,'_blank');
          //   }else{
          //     message('影像调阅失败',false);
          //   }
          // }).catch(() => {
          // })
        }
      },
      readFilm() {
        this.params_image.hospitalId = this.readFirm.hospitalId;
        this.params_image.studyPk = this.readFirm.studyPk+"";
        this.params_image.studyUid = this.readFirm.studyUid;
        this.$nextTick(() => {
          this.$refs.aycanImages.getConsultImages();
        })

        // let Aycan = {
        //   hospitalId:this.readFirm.hospitalId,
        //   studyPk:this.readFirm.studyPk,
        //   studyUid:this.readFirm.studyUid,
        // }
        // http.post('/edu/prepareAycan.json', Aycan).then(res => {
        //   if (res.data.code === "0000") {
        //     let url = res.data.model
        //     window.open(url)
        //   }else{
        //     message(res.data.msg,false);
        //   }
        // }).catch(() => {
        // })
      },
      showBigImg() {
        this.filePop = true
      },
      closeFile() {
        this.filePop = false
      },
      fileCLick(type, obj, index) {
        if(type==='file'){
          this.fileI = index
          this.picI = null
        } else {
          this.fileI = null
          this.picI = index
        }
        this.detailList = getLocalStorage('detail')
        let params = {
          refId: this.detailList.id,
          businessType: 'material'
        }
        http.post('system/getRelateAttachList.json', params).then(res => {
          if (res.data.code === _.ERR_OK) {
            if (obj.attach_type === 'file') {
              for (let item of res.data.model) {
                if (item.fileid === obj.fileid) {
                  //this.url = encodeURI(`https://ow365.cn/?i=15894&furl=${item.fileurl}`)
                  this.url = encodeURI(encodeURI(item.fileurl))
                  this.imgShow = '0'
                  this.defaultShow=false
                }
              }
            } else {
              for (let item of res.data.model) {
                if (item.fileid === obj.fileid) {
                  this.url = item.fileurl
                  this.imgShow = '1'
                  this.defaultShow=false
                }
              }
            }
          }
        })
      },
      getFileVal(val) {
        let params = {
          refId: val,
          businessType: 'case'
        }
        http.post('system/getRelateAttachList.json', params).then(res => {
          if (res.data.code === _.ERR_OK) {
            this.updateFileList= []
            this.updatePicList = []
            for (let item of res.data.model) {
              if (item.attach_type === 'file') {
                this.updateFileList.push(item)
              } else {
                this.updatePicList.push(item)
              }
            }
          } else {
          }
        })
      },
      closePop(val) {
        this.repShow = false
      },
      tabChange(payload) {
        this.isImage = payload.name
        if(this.isImage!=='1'){
          this.isImageTwo = '0'
    /*       this.medicalDetail = '' */
        }

      },
      tabChangeRight(payload) {
        this.isImageTwo = payload.name
      },
      showDetial(val) {
        this.medicalDetail = val
        this._getCaseDetail(val.id)
        this.getFileVal(val.id)
      },
      _getCaseDetail(id) {
        http.post('/caselib/getCaseDetail.json', {id}).then(res => {
          if (res.data.code === _.ERR_OK) {
            this.data2 = []
            this.detail = res.data.model
            if (this.detail.ageUnit === '1') this.detail.ageUnit = '天'
            if (this.detail.ageUnit === '2') this.detail.ageUnit = '周'
            if (this.detail.ageUnit === '3') this.detail.ageUnit = '月'
            if (this.detail.ageUnit === '4') this.detail.ageUnit = '岁'
            if (this.detail.ageUnit === '5') this.detail.ageUnit = '小时'
            for (let item of this.detail.studyList) {
              item.patientSex = changeGender(item.patientSex)
              item.hosArea = changehosArea(item.hosArea)
            if (res.data.model.patientAge == undefined) {
              res.data.model.patientAge = ''
            } else {
              res.data.model.patientAge = res.data.model.patientAge
            }
            }
            this.data2 = this.detail.studyList
          }
        })
      },
      _getReportInfo(val, index) {
        this.check_applicat=val;
        this.imageListI = index
        this.elcRep=val;
        this.readFilmY = true;
        this.readFilmN = false;
        this.reportInfo={}
        let params = {
          hospitalId : val.hospitalId,
          studyPk: val.studyPk,
          studyUid: val.studyUid
        }
        this.readFirm.hospitalId = val.hospitalId
        this.readFirm.studyPk = val.studyPk
        this.readFirm.studyUid = val.studyUid
        http.post('/edu/reportDetail.json', params).then(res => {
          if (res.data.code == "0000") {
            res.data.model.masculineFlag = yinyang(res.data.model.masculineFlag);
            res.data.model.patientSex = changeGender(res.data.model.patientSex);
            res.data.model.studiesDoneDt = nomalTime(res.data.model.studiesDoneDt);
            res.data.model.reportSdt = nomalTime(res.data.model.reportSdt);
            res.data.model.approveDt = nomalTime(res.data.model.approveDt);
            res.data.model.clinicType = changeclinicType(res.data.model.clinicType)
            if (res.data.model.patientAge == undefined) {
              res.data.model.patientAge = ''
            } else {
              res.data.model.patientAge = res.data.model.patientAge
            }
            if(val.reportState !=='3'){
              this.reportInfo = {}
            } else {
              this.reportInfo = res.data.model
            }
          } else {
          }
        })
        this.reportShow = true
        if(val.reportState !=='3'){
          message('该影像暂无报告', false)
          this.reportInfo = {}
        }
        let aDiv = document.getElementsByClassName('list_cell')
        for (let item of aDiv) {
          item.style.background = '#fff'
          item.style.color = '#878e9e'
        }
        aDiv[index].style.background = '#e2e8f6'
      },

      getReport(item,index) {
            return
      },
    },
    watch:{
      'detailList.studyList'(c, o) {
        for (let item of c) {
          if(item.patientAge!==undefined){
            item.patientAge = item.patientAge + changeAge(item.ageUnit)
          } else {
            item.patientAge = ''
          }
        }
        if(c.length>0){
          this.dataShow = true
          this.dataHide = false
        } else {
          this.dataShow = false
          this.dataHide = true
        }
      },
      'detailList.openFlag'(c, o) {
        if(c==='1'){
          this.detailList.openFlag = '公开'
          this.rangeShow = false
        } else if(c==='0'){
          this.detailList.openFlag = '私人'
          this.rangeShow = true
        }
      }
    },
    created() {
      this.detailList = getLocalStorage('detail')
      if(this.detailList.scienceType ===undefined){
        this.scienceTypeData  = '所有'
      } else {
        this.scienceTypeData = this.detailList.scienceType
      }
      this.data = this.detailList.caseList
      for (let item of this.data) {
        if (item.caseSex === '1') {
          item.caseSex = '男'
        } else if(item.caseSex === '0') {
          item.caseSex = '女'
        }
        if(item.caseAge!==undefined){
          if (item.ageUnit === '4') {
            item.caseAge = item.caseAge + '岁'
          } else if (item.ageUnit === '3') {
            item.caseAge = item.caseAge + '月'
          } else if (item.ageUnit === '2') {
            item.caseAge = item.caseAge + '周'
          } else if (item.ageUnit === '1'){
            item.caseAge = item.caseAge + '天'
          } else if(item.ageUnit === '5'){
            item.caseAge = item.caseAge + '小时'
          }
        } else {
          item.caseAge = ''
        }
      }
      if (this.detailList.attachList.length > 0) {
        for (let item of this.detailList.attachList) {
          if (item.attach_type === 'file') {
            this.fileList.push(item)
          } else {
            this.picList.push(item)
          }
        }
      }
      if(this.detailList.attendList.length!=0){
        // let attend = []
        let par = {}
          for (let item of this.detailList.attendList) {
           if(item.attendType == '3'){
            par = {
              id: item.groupId,
              name: item.groupName,
              job: ''
            }
           }else if(item.attendType =='2'){
            par = {
              id: item.hosId,
              name: item.hosName,
              job: ''
            }
           }else if(item.attendType =='1'){
            par = {
              id: item.deptId,
              name: item.deptName,
              job: item.hosName
            }
           }else{
            par = {
              id: item.userId,
              name: item.userName,
              job: ''
              // job: item.docTitle
            }
           }
              this.attendL.push(par)
              this.attendL.forEach(arr =>{
               if(arr.job == ''){
                  arr.attendEm = false
               }else{
                  arr.attendEm = true
               }
              })
          }
            let examinePart = ''
              for (let item of this.attendL) {
                if(item.job != ''){
                  examinePart +="，" + item.name + '（' + item.job + '）';
                }else{
                  examinePart +="，" + item.name
                }
              }
              if (examinePart.substr(0,1)=='，'){
                  examinePart=examinePart.substr(1);
              }
            this.attend = examinePart

      } else {
        // this.attendName = ''
        this.attendL = []
      }
    },
    name: "query-medical-record-info"
  }
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  @import '~@/common/css/variable'
  .nofile
    text-align: center
    line-height:calc((100vh - 250px - 60px) * 0.5 - 36px)

  .querty_content
    width: 100%
    height: 100%

  .course_top
    height: 150px
    background: #fff
    overflow-y: auto

  .label_title
    display: block
    width: 110px
    text-align: right
    float: left
  .info_content
    display: block
    width: calc(100% - 120px)
    float: left
    color: #000
    em
      color $color-maingrey
      font-size: 12px
      font-style:normal
  .query_medicalRecord_left
    background: #fff
    float: left
    width: 30%
    margin-bottom: 20px
    height calc(100vh - 280px)
    overflow: hidden;

  .file_area
    display:flex
    align-items :center
    justify-content :center
    height: calc(100vh - 280px)
  .file_show
    a
      display:block
      width: 80px
      height: 27px
      line-height:27px
      cursor: pointer
      background: #01abac
      color: #fff
      border-radius: 3px
      text-align: center
      margin:10px auto 0
  .tip
    text-align:center
    font-size:100%
  .query_medicalRecord_left_image_content
    height: calc(100vh - 355px)
    overflow-y: auto

  .tabTwo
    padding 0 20px
  .query_medicalRecord_right
    background: #fff
    float: right
    width: 68%
    margin-bottom: 20px

  .check
    background : #e2e8f6;

  .query_medicalRecord_left_content
    // height: 450px
    overflow-y: height

  .list_title
    height: 36px
    line-height: 36px
    background: #8791a2
    color: #fff
    span
      display: inline-block
      text-align: center
      overflow: hidden
      text-overflow : ellipsis
      white-space : nowrap
      font-weight: 900

  .proTxt
    text-align: center
    position: relative
    top: 5vh

  .list_cell
    height: 36px
    line-height: 36px
    span
      display: inline-block
      text-align: center
      overflow: hidden
      text-overflow : ellipsis
      white-space : nowrap

  .list_cell:hover
    background: #f0f0f0

  .cell_dark
    background: #7e8c8d

  .dif_info
    width: 84% !important
    line-height: 18px
    margin-top: -2px

  .cell_light
    background: #fff

  .dataHide
    line-height: calc(100vh - 355px)
    text-align: center

  .remarkTxt
    padding-bottom: 8px

  .readImg
    max-width: 100%
    max-height: 90%
    cursor: pointer
    width: auto
    height: auto

  .query_medicalRecord_left_file_content
    height: calc((100vh - 250px - 60px)*0.5 - 55px )
    overflow-y: auto

  .list_file_title
    text-indent: 14px
    height 100%
    font-weight: 900
  .fj_contents
    height
  .dif_cont
    width: 100%
    position: relative
    top: -18px
    left: 110px
    height: 24px
    line-height: 24px;
    overflow: hidden
    white-space:nowrap
    text-overflow:ellipsis
    cursor: pointer
  .reportContent
    height: calc(100vh - 280px)
    overflow-y: auto
    b
      font-weight bold
    h2
      font-size: 16px
      color: #000
      font-weight bold
      text-align: center
      position: relative
      line-height 40px
      height 40px
    .btn
      position: absolute;
      width: 90px;
      text-align: center;
      height: 30px;
      line-height: 30px;
      top: 5px;
      right: 10px;
      cursor: pointer;
      border-radius: 4px;
      background: #00abad;
      color: #fff;
      font-size: 14px
    .btn2
      background : #aaadb3
      right: 110px !important
    .btn3
      background : #aaadb3
      right: 210px !important
    .btn1
      position: absolute;
      width: 90px;
      text-align: center;
      height: 30px;
      line-height: 30px;
      top: 5px;
      right: 10px;
      cursor: pointer;
      border-radius: 4px;
      background : #aaadb3;
      color: #fff;
      font-size: 14px


  .file_row,.file_row2
    height : 36px
    line-height : 36px
    text-indent: 10px
    width 100%
    white-space:nowrap
    text-overflow:ellipsis
    cursor :pointer
  .file_row:hover
    background :#f0f0f0
  .file_row2:hover
    background :#f0f0f0
  .img_area
    width : 80%
    margin: 0px auto
    height : 100%
    text-align :center

    img
      margin-top : 5%;
  .litBit
    overflow:hidden
    white-space:nowrap
    text-overflow:ellipsis
    cursor :pointer
</style>



// WEBPACK FOOTER //
// querycourseWareInfo.vue?dd58fdf2